import React, {useCallback, useEffect, useRef, useState} from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import styles from './css/Practice.module.css'
import {api} from './Api.js'
import PreflightLoader, {parseISODuration} from "./PreflightLoader";
import {config} from "./Constants";

const AnalizeModalWindow = ({ index, text, comment, speaking, onClose, showNotification, navigate }) => {
  const [analizeResult, setAnalizeResult] = useState(comment);
  const [loading, setLoading] = useState(!comment);
    const [expectedWaitTime, setExpectedWaitTime] = useState(0);
    const requestStartedRef = useRef(false);
    const mountedRef = useRef(true);

    useEffect(() => () => {
        mountedRef.current = false;
    }, []);

  const fetchAnalizeResult = useCallback(async () => {
      // The parent can re-render frequently (for example, while its preflight timer
      // is ticking). Do not let those renders start a second analysis request.
      if (requestStartedRef.current) {
          return;
      }

      requestStartedRef.current = true;
    setLoading(true);
      if (config.enablePreflight) {
          const waitRes = await api.fetchWaitTime('/writing/analyze', navigate, showNotification);
          if (mountedRef.current && api.isValidResponse(waitRes)) {
              setExpectedWaitTime(parseISODuration(waitRes.data.expectedWaitTime));
          }
      }
    const response = await api.fetchAnalizeResult({text, speaking}, navigate, showNotification);
      if (!mountedRef.current) {
          return;
      }

    if (api.isValidResponse(response)) {
      setAnalizeResult(response.data);
        setExpectedWaitTime(0);
    } else {
      onClose(index, comment);
    }
    setLoading(false);
  }, [text, speaking, index, comment, navigate, showNotification, onClose]);

  useEffect(() => {
      if (!comment) {
      fetchAnalizeResult();
    }
  }, [comment, fetchAnalizeResult]);

  if (loading) {
    return (
        <div className={styles.modalLoading}>
            <PreflightLoader expectedWaitTime={expectedWaitTime}/>
        </div>
    )
  }

  return (
      <article className={styles.modalCard} aria-label="Language feedback">
          <header className={styles.modalHeader}>
              <i className="material-icons">psychology</i>
              <h2>Language feedback</h2>
          </header>

          <div className={styles.modalBody}>
            {text && (
                <div className={styles.modalQuote}>
                    <span className={styles.modalQuoteLabel}>Your message</span>
                    <div className={styles.modalQuoteText}>{text}</div>
                </div>
            )}

              <div className={`markdown-content ${styles.feedbackContent}`}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{analizeResult}</ReactMarkdown>
            </div>
          </div>
          <footer className={styles.modalFooter}>
          <button className="waves-effect waves-light btn-large blue darken-2"
                  onClick={() => {
                    onClose(index, analizeResult);
                  }}>
            <i className="material-icons left">check_circle</i>
              Got it
          </button>
          </footer>
      </article>
  );
}

export default AnalizeModalWindow;
